import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router} from "@angular/router";
import {Injectable} from "@angular/core";
import {DataService} from "./services/data.service";
import { Observable } from 'rxjs/Observable';

@Injectable()

export class PersonalCabinetGuard implements CanActivate {

  constructor(private dataService: DataService, private router: Router) {

  }

  canActivate(route: ActivatedRouteSnapshot,
              state: RouterStateSnapshot) :  Observable<boolean> | Promise<boolean> | boolean{
    let access = this.dataService.isAuthenticated();
    console.log(access);
    if (access === true ) {
      return true;
    } else {
      this.router.navigate(['/login']);
      return false;

    }
  }

}



// WEBPACK FOOTER //
// /home/backend/KreditCentr/WebLombard/client/src/app/PersonalCabinetGuard.ts